import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "timeline p-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-line w-40px border-primary" }, null, -1)
const _hoisted_3 = { class: "timeline-icon symbol symbol-circle symbol-40px" }
const _hoisted_4 = { class: "symbol-label bg-light-primary border border-primary" }
const _hoisted_5 = { class: "svg-icon svg-icon-2 svg-icon-primary" }
const _hoisted_6 = { class: "timeline-content mb-10 mt-n1 bg-secondary px-4 py-2 border border-secondary rounded" }
const _hoisted_7 = { class: "mb-5 pe-3" }
const _hoisted_8 = {
  href: "#",
  class: "fs-5 fw-bold text-gray-800 text-hover-primary mb-2"
}
const _hoisted_9 = { class: "d-flex flex-column align-items-start mt-1 fs-6 gap-2" }
const _hoisted_10 = {
  class: /*#__PURE__*/_normalizeClass('badge badge-light')
}
const _hoisted_11 = { class: "text-gray-800 me-2 fs-7" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-calendar-week fs-4 fw-bold text-primary me-2" }, null, -1)
const _hoisted_13 = {
  key: 0,
  class: "text-gray-800 me-2 fs-7"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person-fill fs-4 fw-bold text-primary me-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listItems, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "timeline-item",
        key: 'lst-h-' + index
      }, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/communication/com003.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("a", _hoisted_8, _toDisplayString(item.message), 1),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, "Estado: " + _toDisplayString(item.mstatus), 1),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("span", null, _toDisplayString(_ctx.moment(item.created_at).format('DD/MM/YYYY HH:mm')), 1)
              ]),
              (_ctx.username?.idperfil == 1 || _ctx.username?.idperfil == 8)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("span", null, _toDisplayString(item.username), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]))
    }), 128)),
    (_ctx.listItems.length == 0)
      ? (_openBlock(), _createBlock(_component_el_empty, {
          key: 0,
          description: _ctx.t('notFoundResult'),
          image: "/media/svg/illustrations/sigma/question.svg",
          "image-size": 300
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "warning",
              onClick: _ctx.getListItems
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('tryAgain')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["description"]))
      : _createCommentVNode("", true)
  ])), [
    [_directive_loading, _ctx.loader]
  ])
}